import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../services/api';

export default function ClinicInvitationPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get(`/clinic-invitations/${token}`).then((response) => setInfo(response.data)).catch((requestError) => setError(requestError?.response?.data?.detail || 'Convite inválido ou expirado.')).finally(() => setLoading(false));
  }, [token]);

  const accept = async (event) => {
    event.preventDefault();
    try {
      setSaving(true); setError('');
      await api.post('/clinic-invitations/accept', { token, password: info?.existing_user ? null : password });
      setSuccess(true);
    } catch (requestError) { setError(requestError?.response?.data?.detail || 'Não foi possível aceitar o convite.'); }
    finally { setSaving(false); }
  };

  return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4"><div className="w-full max-w-md bg-white border rounded-xl shadow-sm p-6">
    {loading ? <p className="text-center text-gray-500">Validando convite...</p> : success ? <div className="text-center"><h1 className="text-xl font-semibold text-emerald-700">Acesso ativado</h1><p className="text-sm text-gray-600 mt-3">Seu acesso à clínica foi ativado com sucesso.</p><Link to="/login" className="inline-flex mt-6 px-4 py-2 bg-purple-600 text-white rounded-lg">Ir para o login</Link></div> : error && !info ? <div className="text-center"><h1 className="text-xl font-semibold text-red-700">Convite indisponível</h1><p className="text-sm text-gray-600 mt-3">{error}</p></div> : <form onSubmit={accept}>
      <h1 className="text-xl font-semibold text-gray-900">Convite para colaborar</h1>
      <p className="text-sm text-gray-600 mt-2"><b>{info?.full_name}</b>, você foi convidado para acessar <b>{info?.clinic_name || 'uma clínica'}</b> no OdontoAssist AI.</p>
      <p className="text-sm text-gray-500 mt-2">Conta: {info?.email}</p>
      {!info?.existing_user && <><label className="block text-sm font-medium mt-5 mb-1">Crie sua senha</label><input required type="password" minLength={8} maxLength={128} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border rounded-lg px-3 py-2" /><p className="text-xs text-gray-500 mt-1">Use maiúscula, minúscula, número e símbolo.</p></>}
      {info?.existing_user && <p className="mt-5 p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-700">Este e-mail já possui uma conta. O convite será associado à senha existente.</p>}
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <button disabled={saving} className="w-full mt-6 px-4 py-2 bg-purple-600 text-white rounded-lg disabled:opacity-60">{saving ? 'Ativando...' : 'Aceitar convite'}</button>
    </form>}
  </div></div>;
}
